/*
 * @Author: zl
 * @Date: 2022-03-08 13:50:03
 * @LastEditTime: 2022-08-05 09:53:19
 * @LastEditors: zl
 * @Description: 
 */
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import './assets/style/global.less';
import './assets/style/layout.less';
import './assets/style/lib.less';
import './assets/style/transtion.less';

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import request from './api/request'

import './icons' // icon
import './utils/nprogress' // nprogress进度条
import './utils/extends'
import './utils/directive'

// 加载 vxe-table
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import './utils/vxe-table-extends'

// 设置全局预览 环境变量
Vue.prototype.$previewUrl = process.env.VUE_APP_PREVIEW_URL || ''

// 删除二次确认函数
import { deleteConfirm } from './utils/tools'
Vue.prototype.$deleteConfirm = deleteConfirm

Vue.use(VXETable)
Vue.prototype.$utils = XEUtils

// 引入 vue-treeselect
import treeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// 引入 wSplit
import wSplit from './components/split/split'

// 引入searchArea
import searchArea from './components/searchArea/searchArea'

// 引入 filterArea
import filterArea from './components/filterArea/filterArea'

// 全局注册组件
Vue.component('treeSelect', treeSelect)	
Vue.component('wSplit', wSplit)
Vue.component('searchArea', searchArea)
Vue.component('filterArea', filterArea)

// 雪花id
import { Snowflake } from 'node-snowflake'
Vue.prototype.Snowflake = Snowflake

// 用mockjs 模拟数据
import './mock'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;
Vue.use(ElementUI);

console.log(process.env, 'prod-dingx');

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
